import ValueCalculator from "../../util/ValueCalculator";
import NumberValue from "../value/NumberValue";

export default class SkillActivationTimer {
    /**
     * @param {NumberValue} durationUpgrades
     * @param {NumberValue} coolDownUpgrades
     */
    constructor(durationUpgrades, coolDownUpgrades) {
        /**
         * @constant
         * @type {NumberValue}
         */
        this.durationUpgrades = durationUpgrades;
        /**
         * @constant
         * @type {NumberValue}
         */
        this.coolDownUpgrades = coolDownUpgrades;

        /**
         * @type {boolean}
         */
        this.skillActive = false;

        /**
         * @type {number}
         */
        this.startTurn = 0;
    }

    /**
     * @param {number} turnNumber
     * @param {number} offset 
     */
    initialize(turnNumber, offset) {
        this.skillActive = false;

        // Subtract coolDownTurns to get the skills to happen right away.
        this.startTurn = (turnNumber - ValueCalculator.getSkillCoolDownTurns(this.coolDownUpgrades)) + offset;
    }

    /**
     * @param {number} turnNumber 
     */
    updateForTurn(turnNumber) {
        const elapsedTurns = turnNumber - this.startTurn;

        // See if the skill is done being active.
        if (this.skillActive) {
            this.skillActive = elapsedTurns < ValueCalculator.getSkillActivationTurns(this.durationUpgrades);
        }

        // See if we have waited long enough to start the skill again.
        else if (elapsedTurns > ValueCalculator.getSkillCoolDownTurns(this.coolDownUpgrades)) {
            // Update the start turn to this turn.
            this.startTurn = turnNumber;

            // It's time to activate the next skill
            this.skillActive = true;
        }

    }

    /**
     * @returns {boolean}
     */
    isSkillActive() {
        return this.skillActive;
    }

}